export default __webpack_public_path__ + "static/special-folder-18fd79044385c616ca1f04854e83c9e3.webp";